exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2yk2D span{margin-right:30px}._2yk2D{position:relative;display:block;margin-bottom:4px;font-size:14px;color:#888;font-weight:400}._3JXp4{font-weight:700;margin-top:5px;display:inline-block;font-size:17px;padding:2px 0;border-radius:2px;color:#000}._3p3D5:hover ._2jmjC{color:#e73232}._2jmjC{font-size:15px;font-weight:700;margin-bottom:4px}", ""]);

// exports
exports.locals = {
	"info": "_2yk2D",
	"price": "_3JXp4",
	"root": "_3p3D5",
	"title": "_2jmjC"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/AdvertCard/SimpleCard/SimpleCard.css
// module id = 1864
// module chunks = 0 20 24 33 36